import { useGetLineItemUnitTypesAll } from "@birdwatch/client";

export const useUnitTypes = () => {
  return useGetLineItemUnitTypesAll().query({ take: 999 }).get({
    staleTime: Infinity,
    gcTime: Infinity,
  });
};
